import fetcher from 'api/fetcher';
import { OverflowTypeSearch } from 'utils/constants/admin';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setLoadOverflows, setOverflows, setSorts } from 'store/models/overflow';

export default () => {
    return (dispatch, getState) => {
        const { from, to, typeSearch, campaignId } = getState().overflow;
        dispatch(setLoadOverflows(true));
        let path = 'campaign_overflow_for_period';
        let params = {
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        };
        if (typeSearch === OverflowTypeSearch.Id) {
            params = { campaignId };
            path = 'campaign_overflow';
        }
        const queryStr = urlParser.stringify(params);
        return fetcher
            .get(`/api/v1/backoffice/${path}/?${queryStr}`, { timeout: 40000 })
            .then((overflows) => {
                dispatch([setOverflows(overflows), setLoadOverflows(false), setSorts([])]);
            })
            .catch(() => {
                dispatch([setOverflows([]), setLoadOverflows(false), setSorts([])]);
            });
    };
};
